import { addMutator } from '@poa/state';

import { setCurrentCountry, setTypePayment, setTypeCard, setCard } from './payment.actions';

addMutator(setCurrentCountry, (payload, { store }) => {
  if (payload === null)
    return (store.payment.currentCountry = {
      label: null,
      value: null
    });
  store.payment.currentCountry = { ...payload };
});

addMutator(setTypePayment, (payload, { store }) => {
  if (payload === null)
    return (store.payment.currentTypePayment = {
      label: null,
      value: null
    });
  store.payment.currentTypePayment = { ...payload };
});

addMutator(setTypeCard, ({ label, value }, { store }) => {
  console.log('payload', store.payment.currentCountry.value);
  switch (store.payment.currentCountry.value) {
    case 'ukraine':
      return (store.payment.optionCard = [
        {
          label: 'Приват банк',
          value: 'privat'
        },
        {
          label: 'Моно банк',
          value: 'mono'
        },
        {
          label: 'Ощад банк',
          value: 'oschad'
        },
        {
          label: 'Альфа банк',
          value: 'bank'
        }
      ]);
    case 'russian':
      return (store.payment.optionCard = [
        {
          label: 'Банк 44',
          value: 'bank1'
        },
        {
          label: 'Банк 45',
          value: 'bank2'
        }
      ]);
    case 'belarus':
      return (store.payment.optionCard = [
        {
          label: 'Банк 12',
          value: 'bank1'
        },
        {
          label: 'Банк 11',
          value: 'bank2'
        }
      ]);
    case 'kazakhstan':
      return (store.payment.optionCard = [
        {
          label: 'Банк 3',
          value: 'bank1'
        },
        {
          label: 'Банк 4',
          value: 'bank2'
        }
      ]);
    default:
      return;
  }
});

addMutator(setCard, (payload, { store }) => {
  if (payload === null)
    return (store.payment.selectedOptionCard = {
      label: null,
      value: null
    });
  store.payment.selectedOptionCard = { ...payload };
});
